import { computed, inject } from '@angular/core';
import { LocalizationService } from '../../core/localization/localization.service';
import { OFFERING_PROFILE_TYPE_VALUES, profileTypeLabelKey } from './offering-profile-schemas';

/** Reactive profile-type dropdown options from API localization resources. */
export function offeringProfileTypeOptions() {
  const localization = inject(LocalizationService);
  return computed(() => {
    localization.resources();
    localization.activeCulture();
    return OFFERING_PROFILE_TYPE_VALUES.map(value => ({
      value,
      label: localization.translate(profileTypeLabelKey(value))
    }));
  });
}
